import { useState } from 'react';
import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useSendNotification = () => {
  const [shortMessage, setShortMessage] = useState('');

  const handleAddMessage = () => {
    console.log(shortMessage);
  };

  const sendNotificationData = async (checkedEmails, checkedSMS) => {
    try {
      const basePayload = {
        notificationSubject: 'Site Assessment Notification',
        notificationBody: `${shortMessage}` || 'New site Assesment Added',
        sendCC: '',
        originatedFrom: 'Notification Page',
        notificationSendDateTime: toLocalISO(),
        recordDateTime: toLocalISO(),
        flag: 0,
      };

      if (checkedEmails.length > 0) {
        const emailPayload = {
          ...basePayload,
          sendTo: checkedEmails.join(','),
          notificationDeliveryType: 'EMAIL',
          smsBody: '',
        };

        await customAxios.post('/GenTasks/AddNotifications', emailPayload, {
          headers: authHeader(),
        });
      }

      if (checkedSMS.length > 0) {
        const smsPayload = {
          ...basePayload,
          sendTo: checkedSMS.join(','),
          notificationDeliveryType: 'SMS',
          notificationBody: '',
          notificationSubject: '',
          smsBody: `${shortMessage}` || 'New site Assesment Added.',
        };

        const msg = await customAxios.post('/GenTasks/AddNotifications', smsPayload, {
          headers: authHeader(),
        });
        console.log('Notifications sent successfully.', msg);
      }
    } catch (error) {
      console.error('Failed to send notifications:', error);
    }
  };

  return { sendNotificationData, shortMessage, setShortMessage, handleAddMessage };
};

export default useSendNotification;
